import { css, Stack, styled, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';

import DatSimLogo from '@/assets/logos/logo.svg?react';
import { useUIStore } from '@/stores/useUIStore';
import { transientOptions } from '@/utils/transient-options';

const HeaderRoot = styled(Stack)(
  () => css`
    display: flex;
    align-items: center;
  `,
);

const LogoContainer = styled(Stack)(
  ({ theme }) => css`
    position: relative;
    height: 68px;
    width: 100%;
    background-color: ${theme.palette.primary.main};
    transition: width 200ms ${theme.transitions.easing.easeInOut};
    overflow: hidden;
    will-change: width;
    -webkit-font-smoothing: antialiased;

    @media (prefers-reduced-motion: reduce) {
      transition: none;
    }
  `,
);

const Logo = styled(DatSimLogo)(css`
  position: absolute;
  inset: 0;
`);

const LogoTextWrapper = styled(
  Stack,
  transientOptions,
)<{ $expanded: boolean }>(
  ({ theme, $expanded }) => css`
    position: absolute;
    left: ${theme.spacing(9.5)};
    top: 50%;
    transform: translateY(-50%);
    opacity: ${$expanded ? 1 : 0};
    transition: opacity 120ms ${$expanded ? '200ms' : '0ms'} ease-out;
    color: ${theme.palette.primary.contrastText};
    pointer-events: none;
  `,
);

const StyledLink = styled(Link)(css`
  display: block;
  width: 100%;
  height: 100%;
  position: relative;
  text-decoration: none;
  color: inherit;
`) as unknown as typeof Link;

export function Header() {
  const sidebarExpanded = useUIStore((state) => state.sidebarExpanded);

  return (
    <HeaderRoot>
      <LogoContainer>
        <StyledLink to="/">
          <Logo title="DatSIM kompakt" />
          <LogoTextWrapper $expanded={sidebarExpanded}>
            {sidebarExpanded ? <Typography sx={{ fontSize: '1.3125rem', lineHeight: 1.2 }}>DatSIM 2.0</Typography> : null}
          </LogoTextWrapper>
        </StyledLink>
      </LogoContainer>
    </HeaderRoot>
  );
}
